const nfc = {
	nfcCards: 'Tarjetas NFC',
	subtitle:
		'Las tarjetas se dan de alta en tandas con el botón +, leyéndolas desde Chrome en un teléfono Android con NFC.',
	scanWaitingCancel: 'Apoyá la tarjeta… (cancelar)',
	scanDenied: 'El navegador no tiene permiso para usar NFC. Habilitalo en los permisos del sitio.',
	scanUnsupported: 'El NFC del teléfono está apagado o no está disponible. Activalo en los ajustes.',
	scanStartFailed: 'No se pudo iniciar la lectura NFC. Probá de nuevo.',
	scanReadFailed: 'Se detectó una tarjeta pero no se pudo leer. Apoyala de nuevo y dejala quieta.',
	scanInvalidUid: 'La tarjeta leída no tiene un UID válido.',
	findByScan: 'Buscar apoyando una tarjeta',
	findNotRegistered: 'La tarjeta leída no está dada de alta.',
	scanFilter: 'Tarjeta leída',
	cardNamed: 'la tarjeta «{{label}}»',
	cardUnnamed: 'esta tarjeta',
	cardWithoutLabel: 'Tarjeta sin etiqueta',
	cardNumber: 'Tarjeta {{number}}',
	batchTitle: 'Alta de tarjetas',
	batchHelp:
		'Armá la plantilla de la tanda, apretá Leer tarjetas y apoyá las tarjetas una tras otra en la parte de atrás del teléfono. Leerlas solo las junta en la lista: se crean todas juntas, con un solo toque, al final.',
	batchUnavailable:
		'Para dar de alta tarjetas abrí el panel en Chrome desde un teléfono Android, con el NFC activado.',
	batchInsecure:
		'Chrome solo lee tarjetas en una conexión segura. Abrí el panel por https:// (o por localhost) en lugar de una dirección IP.',
	batchTemplate: 'Plantilla',
	batchOptionalHelp: 'Opcional, igual para todas las tarjetas de la tanda',
	batchDateInvalid: 'La fecha no es válida o ya pasó',
	batchBalance: 'Saldo a cargar',
	batchBalanceHelp: 'Opcional, se carga a cada tarjeta',
	batchProducts: 'Productos a cargar',
	batchProductsHelp:
		'Opcional: se carga el mismo pedido en cada tarjeta, para retirar en la barra de la sección elegida.',
	batchCards: 'Tarjetas',
	batchStart: 'Leer tarjetas',
	batchResume: 'Seguir leyendo',
	batchPause: 'Pausar',
	batchScanning: 'Leyendo: apoyá las tarjetas una tras otra. Una que ya está en la lista se ignora.',
	batchCount: 'Tarjetas leídas: {{count}}',
	batchEmpty: 'Todavía no se leyó ninguna tarjeta.',
	batchRemove: 'Quitar la tarjeta {{number}} de la lista',
	batchTooMany: 'Se pueden crear hasta {{max}} tarjetas por tanda. Quitá algunas de la lista.',
	batchCreate: 'Crear las {{count}} tarjetas',
	batchRetry: 'Reintentar crear las {{count}} tarjetas',
	batchUncertain:
		'No se pudo confirmar si la tanda se creó. Reintentá: si ya se había creado, no se crea dos veces. Hasta entonces la plantilla y la lista quedan fijas.',
	batchCreatedCount: 'Tarjetas creadas: {{count}}',
	batchCreatedBalance: 'Saldo de cada tarjeta: {{amount}}',
	batchCreatedProducts: 'Productos cargados en cada tarjeta, total calculado por el servidor: {{total}}',
	batchRetried: '{{count}} ya se habían creado en un intento anterior de esta tanda; no se crearon de nuevo.',
	batchDiscardTitle: 'Salir sin crear las tarjetas',
	batchDiscardDescription: 'Leíste {{count}} tarjetas que todavía no se crearon. Si salís, la lista se pierde.',
	batchDiscard: 'Salir sin crear',
	label: 'Etiqueta',
	responsable: 'Responsable',
	expiresAt: 'Vencimiento',
	filterState: 'Estado',
	filterAll: 'Todos',
	filterAllFemale: 'Todas',
	sort: 'Orden',
	sortNewest: 'Más nuevas primero',
	sortBalanceDesc: 'Saldo: mayor primero',
	sortBalanceAsc: 'Saldo: menor primero',
	sortOperationsDesc: 'Operaciones: más primero',
	sortOperationsAsc: 'Operaciones: menos primero',
	sortExpiresAtAsc: 'Vencimiento: más próximo primero',
	sortExpiresAtDesc: 'Vencimiento: más lejano primero',
	sortResponsableAsc: 'Responsable: A a Z',
	sortResponsableDesc: 'Responsable: Z a A',
	operationsCount: 'Operaciones: {{count}}',
	stateActive: 'Activa',
	stateBlocked: 'Bloqueada',
	stateExpired: 'Vencida',
	expiredTag: '(vencida)',
	scannedExpired: 'La tarjeta está vencida: no se puede usar ni cargar. Cambiá su vencimiento para volver a usarla.',
	scannedExpiredOn:
		'La tarjeta venció el {{date}}: no se puede usar ni cargar. Cambiá su vencimiento para volver a usarla.',
	changeExpiration: 'Vencimiento',
	expirationTitle: 'Cambiar el vencimiento de {{card}}',
	expirationDescription:
		'La tarjeta se puede usar hasta el final del día elegido. Sin fecha, no vence. Si está bloqueada, sigue bloqueada: desbloqueala después.',
	expirationSave: 'Guardar',
	expirationSaved: 'Vencimiento actualizado',
	empty: 'No hay tarjetas que coincidan con lo que buscaste.',
	failed: 'No se pudieron leer las tarjetas. Probá recargar la pantalla.',
	block: 'Bloquear',
	unblock: 'Desbloquear',
	blockTitle: 'Bloquear tarjeta',
	blockDescription:
		'¿Seguro que querés bloquear {{card}}? Mientras esté bloqueada no se va a poder cobrar con ella ni entregar sus pedidos.',
	blocked: 'Tarjeta bloqueada',
	unblocked: 'Tarjeta desbloqueada',
	labelBlockAll: 'Bloquear todas ({{count}})',
	labelUnblockAll: 'Desbloquear todas ({{count}})',
	labelBulkHelp: 'Bloquear y desbloquear todas cambia solo las tarjetas cuya etiqueta es exactamente «{{label}}».',
	labelBlockTitle: 'Bloquear todas las tarjetas de la etiqueta',
	labelBlockDescription:
		'¿Seguro que querés bloquear {{count}} tarjetas con la etiqueta «{{label}}»? Mientras estén bloqueadas no se va a poder cobrar con ellas ni entregar sus pedidos.',
	labelUnblockTitle: 'Desbloquear todas las tarjetas de la etiqueta',
	labelUnblockDescription:
		'¿Seguro que querés desbloquear {{count}} tarjetas con la etiqueta «{{label}}»? Las vencidas quedan bloqueadas y no están en la cuenta.',
	labelBlocked: 'Se bloquearon {{count}} tarjetas',
	labelUnblocked: 'Se desbloquearon {{count}} tarjetas',
	selectedCount: 'Seleccionadas: {{count}}',
	clearSelection: 'Limpiar selección',
	loadProducts: 'Cargar productos a las seleccionadas',
	selectAll: 'Seleccionar todas las de la página',
	selectOne: 'Seleccionar {{card}}',
	backToList: 'Volver a las tarjetas',
	cardFailed: 'No se pudo leer la tarjeta. Probá recargar la pantalla.',
	loadProductsOne: 'Cargar productos',
	loadTitle: 'Cargar productos ({{count}} tarjetas)',
	loadSection: 'Sección',
	loadNone: 'Sin productos',
	loadNoSections: 'No hay secciones para elegir, o no se pudieron leer.',
	loadNothingPicked: 'Elegí al menos un producto, o "Sin productos" en la sección.',
	loadSearch: 'Buscar producto',
	loadNoProducts: 'Esta sección no tiene productos con precio.',
	product: 'Producto',
	price: 'Precio',
	mixer: 'Mixer',
	quantity: 'Cantidad',
	withoutMixer: 'Sin mixer',
	pickMixer: 'Elegí un mixer',
	loadMissingMixer: 'Hay productos que necesitan un mixer elegido.',
	loadEstimatedTotal: 'Total estimado por tarjeta: {{total}}',
	loadTotalHelp: 'El total final lo calcula el servidor con los precios del catálogo al guardar.',
	loadSave: 'Cargar',
	loadTooMany: 'Se pueden cargar hasta {{max}} tarjetas por vez. Achicá la selección.',
	loadedCount: 'Tarjetas cargadas: {{count}}',
	loadedTotal: 'Total por tarjeta calculado por el servidor: {{total}}',
	loadRetried: '{{count}} ya tenían esta misma carga de un intento anterior; no se cargaron de nuevo.',
	orders: 'Cargas',
	ordersEmpty: 'Esta tarjeta todavía no tiene cargas.',
	ordersFailed: 'No se pudieron leer las cargas de la tarjeta. Probá recargar la pantalla.',
	products: 'Productos',
	total: 'Total',
	orderStatus: 'Estado',
	orderDate: 'Fecha de carga',
	orderActive: 'Pendiente de retiro',
	orderClosed: 'Retirada',
	orderCancelledStatus: 'Anulada',
	cancelOrder: 'Anular',
	cancelOrderTitle: 'Anular carga',
	cancelOrderDescription:
		'¿Seguro que querés anular la carga {{code}}? Ya no se va a poder retirar en la barra.',
	orderCancelled: 'Carga anulada',
	balance: 'Saldo',
	balanceCurrent: 'Saldo actual',
	balanceFailed: 'No se pudo leer el saldo de la tarjeta. Probá recargar la pantalla.',
	balanceAmount: 'Monto a cargar',
	balanceAmountInvalid: 'Ingresá un monto mayor a cero',
	balanceLoad: 'Cargar saldo',
	balanceLoaded: 'Se cargaron {{amount}}',
	balanceAlreadyLoaded: 'Esa carga ya se había hecho en un intento anterior; no se cargó de nuevo',
	balanceUnusable: 'La tarjeta está bloqueada o vencida: no se le puede cargar saldo, solo dejarlo en cero.',
	balancePendingAttempt:
		'La última carga no se pudo confirmar. Reintentá con el mismo monto: si ya había entrado, no se carga dos veces.',
	balanceDiscardAttempt: 'Descartar y empezar otra carga',
	balanceDiscardTitle: 'Descartar la carga sin confirmar',
	balanceDiscardDescription:
		'Antes de descartarla, revisá en los movimientos si la carga de {{amount}} entró. Si la descartás y la volvés a hacer, puede cargarse dos veces.',
	balanceDiscard: 'Descartar',
	balanceReset: 'Dejar en cero',
	balanceResetTitle: 'Dejar el saldo en cero',
	balanceResetDescription: '¿Seguro que querés dejar en cero el saldo de {{card}}? Hoy tiene {{balance}}.',
	balanceResetDone: 'Saldo en cero. Se quitaron {{amount}}',
	transactions: 'Movimientos',
	transactionsEmpty: 'No hay movimientos que coincidan.',
	transactionsFailed: 'No se pudieron leer los movimientos de la tarjeta. Probá recargar la pantalla.',
	transactionType: 'Tipo',
	transactionAmount: 'Monto',
	transactionBalanceAfter: 'Saldo resultante',
	transactionOrder: 'Consumo',
	transactionOrderId: 'Pedido',
	transactionBy: 'Quién',
	transactionDate: 'Fecha',
	transactionLoad: 'Carga',
	transactionReset: 'Puesta en cero',
	transactionRefund: 'Devolución',
	transactionBar: 'Barra',
	transactionsFilters: 'Filtros',
	transactionsFiltersClear: 'Limpiar filtros',
	transactionsFilterAll: 'Todos',
	transactionsFilterFrom: 'Desde',
	transactionsFilterTo: 'Hasta',
	transactionsDateInvalid: 'Alguna de las fechas no es válida',
	transactionsDateRangeInvalid: 'La fecha de inicio es posterior a la de fin',
	transactionsFiltersHelp: 'Elegí los filtros y apretá Buscar.',
	// Reports (MUTE-616): what was consumed with a card is not Mute's revenue
	muteCard: 'Tarjeta Mute',
	muteCardDiscount: 'Descontar Tarjeta Mute',
	muteCardDiscountHelp:
		'Resta de los totales lo consumido con tarjetas Mute (cortesías, mesas pagadas por fuera). Las cargas de productos no tienen monto cobrado.',
	muteCardYes: 'Sí',
	muteCardNo: 'No',
} as const;

export default nfc;
